<template>
  <v-row>
    <v-col cols="12">
      <v-card>
        <v-card-title>
          Annual Review Settings
        </v-card-title>
        <v-divider></v-divider>
        <v-form ref="form" v-model="valid">
          <v-card-text class="subtitle-1">
            <v-row>
              <v-col cols="12" class="font-weight-bold pb-0 secondary--text">
                Annual Review Time Period
              </v-col>
              <v-col cols="12" class="pt-0">
                Select the time period for when you'll enable annual reviews to
                be collected and reviewed
              </v-col>
              <v-col cols="auto">
                <v-menu
                  v-model="startdate_menu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      :value="formattedStartDate"
                      outlined
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      label="Start Date"
                      :rules="[$rules.required]"
                      append-icon="today"
                      @click:append="startdate_menu = true"
                    >
                    </v-text-field>
                  </template>
                  <v-date-picker
                    v-model="startDate"
                    @input="startdate_menu = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="auto">
                <v-menu
                  v-model="enddate_menu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      :value="formattedEndDate"
                      outlined
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      label="End Date"
                      :rules="[$rules.required]"
                      append-icon="today"
                      @click:append="enddate_menu = true"
                    >
                    </v-text-field>
                  </template>
                  <v-date-picker
                    v-model="endDate"
                    @input="enddate_menu = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" class="font-weight-bold pb-0 secondary--text">
                Annual Review Questions
              </v-col>
              <v-col cols="12" class="pt-0">
                What should we ask your employees?
              </v-col>
              <v-col cols="12">
                <v-btn
                  outlined
                  color="secondarytext"
                  to="/features/annual-reviews/settings/questions"
                >
                  Manage Questions
                </v-btn>
              </v-col>
              <v-col cols="12">
                <info-card icon="wifi_tethering" title="Preview Summary">
                  Every year starting {{ startDate | monthDateNoTz }},
                  CoreCounts will activate Annual Reviews for your company. That
                  process can be viewed in more detail here. On
                  {{ endDate | monthDateNoTz }}, the review period will expire
                  and all reviews must be completed by that time period.
                </info-card>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-btn @click="save" :loading="saving">Save</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import moment from "moment";
import { mapGetters } from "vuex";
export default {
  name: "AnnualReviewSettings",
  data: () => ({
    saving: false,
    valid: false,
    startdate_menu: false,
    enddate_menu: false,
    statusItems: [
      { id: true, name: "Active" },
      { id: false, name: "Inactive" }
    ]
  }),
  computed: {
    startDate: {
      get() {
        return `${moment().year()}-${this.settings.annualReviewStartMonth}-${
          this.settings.annualReviewStartDay
        }`;
      },
      set(val) {
        let date = moment(val);
        this.settings.annualReviewStartMonth = date.month() + 1;
        this.settings.annualReviewStartDay = date.date();
      }
    },
    endDate: {
      get() {
        return `${moment().year()}-${this.settings.annualReviewEndMonth}-${
          this.settings.annualReviewEndDay
        }`;
      },
      set(val) {
        let date = moment(val);
        this.settings.annualReviewEndMonth = date.month() + 1;
        this.settings.annualReviewEndDay = date.date();
      }
    },
    formattedStartDate() {
      if (this.startDate) {
        return moment(this.startDate).format("MMMM D");
      }
      return "";
    },
    formattedEndDate() {
      if (this.endDate) {
        return moment(this.endDate).format("MMMM D");
      }
      return "";
    },
    ...mapGetters({
      settings: "profile/settings"
    })
  },
  methods: {
    save() {
      if (this.$refs.form.validate()) {
        this.saving = true;
        this.$store
          .dispatch("settings/saveAnnualReviewSettings", this.settings)
          .then(() => {
            this.$emit("save");
            this.$root.$snackbarSuccess("Annual Review Settings saved");
          })
          .catch(error => {
            this.logError(error);
            this.$root.$alert(
              "Error Occurred",
              "An error occurred while saving your annual review settings."
            );
          })
          .finally(() => {
            this.saving = false;
          });
      }
    }
  }
};
</script>
